import React, { useContext } from 'react';

import {
  InputLabel,
} from 'components/form/prototypes';
import { NCRContext } from 'views';
import { currencySymbol } from 'utils/helpers';

const TotalCosts = () => {

  const { state } = useContext(NCRContext);

  const isDisabled = true;

  return (
    <>
      <InputLabel
        name='ncr.order.item_cost'
        label='Total Item Cost'
        value={currencySymbol(state.currencies[state.ncr.subsidiary?.currency], state.ncr.order.item_cost)}
        disabled={isDisabled} />
      <InputLabel
        name='ncr.order.total_cost'
        label='Total Cost'
        value={currencySymbol(state.currencies[state.ncr.subsidiary?.currency], state.ncr.order.total_cost)}
        disabled={isDisabled} />
    </>
  )
}
export { TotalCosts }
